import { useState } from 'react';
import styles from './ExpandableValue.module.css';

/** Keep dense metadata compact while offering the complete value on touch and keyboard. */
export function ExpandableValue({ value, label }: { value: string; label: string }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <details className={styles.value} onToggle={event => setExpanded(event.currentTarget.open)}>
      <summary role="button" aria-expanded={expanded} aria-label={`Show full ${label}`} title={value}>
        <span className={styles.preview}>{value}</span>
      </summary>
      <div className={styles.fullValue}>{value}</div>
    </details>
  );
}
